import React from 'react';
import PropTypes from 'prop-types';

// DS
import { VertAlert } from '@vertem-core/vertice-ds';

const checkSubMessage = (error) => error === '#DoNotShowDescription' ? '' : error;

const createULFromSubs = (subs, subMessage) => {
  if (!subs || !Array.isArray(subs)) {
    return '';
  }
  return (
    <ul>
      {subMessage && <li>{ subMessage }</li>}
      {subs.map((sub, index) => {
        // Type: 290 is sku unavailable
        if (sub && typeof sub === 'object' && sub.message && sub.type !== 290) {
          return <li key={index}>{sub.message}</li>
        }
        return null
      })}
    </ul>
  )
};

// CART ALERT COMPONENT
const ToastErrorAlert = ({ error, className }) => {
	/* padrão */
  let errorMessage = 'Não foi possível concluir.';
  let subErrorMessage = 'Por favor tente novamente em instantes';
  let complementMessages = createULFromSubs(error?.subs, subErrorMessage);

  if (/(OnBoarding)+/.test(complementMessages)) {
	  complementMessages = 'Para garantir a segurança da sua conta, é necessário validar o seu número de telefone antes de prosseguir. Entre em contato com a central de atendimento.'
  }

  if (error) {
		if (typeof error === 'string') {
			// Se for uma string, mostrar mensagem
			subErrorMessage = error;
		}else if (Array.isArray(error.errors)) {
			// Se for um array, mostrar primeiro erro
			const firstError = error.errors[0];
			if (firstError) {
				errorMessage = (typeof firstError === 'string') ? firstError: firstError.message || errorMessage;
				subErrorMessage = checkSubMessage(firstError.subMessage) || '';
			}
		} else if (error.error) {
			// Se for um objeto erro
			errorMessage = error.error.message || errorMessage;
			subErrorMessage = checkSubMessage(error.error.subMessage) || '';
		} else {

			if (error?.message) errorMessage = error?.message;
			if (checkSubMessage(error?.subMessage) !== '') subErrorMessage = error?.subMessage
		}
	}

  /* Renders */
  return (
    <VertAlert
      className={`toast-alert  ${className}`}
      message={errorMessage}
      description={complementMessages || subErrorMessage}
      size='small'
      type='error'
    />
  );
};

ToastErrorAlert.propTypes = {
  error: PropTypes.string.isRequired || PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default ToastErrorAlert;
